export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR'
export const LOGOUT_USER = 'LOGOUT_USER'
export const SELECT_WORKCENTER_REQUIRED = 'SELECT_WORKCENTER_REQUIRED'
export const SWITCH_WORKCENTER_REQUESTED = 'SWITCH_WORKCENTER_REQUESTED'
export const TALLY_REQUIRED = 'TALLY_REQUIRED'
export const TALLY_CANCELLED = 'TALLY_CANCELLED'
export const GET_CONFIG = 'GET_CONFIG'
export const SET_LANG = 'SET_LANG'
export const API_ERROR = 'API_ERROR'
export const GET_PRODUCTIONS = 'GET_PRODUCTIONS'
export const GET_OPERATIONS = 'GET_OPERATIONS'
export const GET_OPERATION = 'GET_OPERATION'
export const SET_OPERATION_STATE = 'SET_OPERATION_STATE'
export const GET_STOP_REASONS = 'GET_STOP_REASONS'
export const RETURN_TO_PRODUCTIONS = 'RETURN_TO_PRODUCTIONS'
export const RETURN_TO_OPERATIONS = 'RETURN_TO_OPERATIONS'
